import { IonList, IonItem, IonThumbnail, IonLabel, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonRow, IonText, IonTitle, IonToolbar, useIonAlert,useIonRouter,useIonViewDidEnter,useIonViewWillEnter,withIonLifeCycle } from '@ionic/react';
import React, { useEffect, useState} from 'react';
import  {
    BarcodeScanner,

  } from '@capacitor-mlkit/barcode-scanning';

import "./DiccMaya.css"
import { RouteComponentProps, useHistory} from 'react-router';
import { arrowBack,alarmSharp,linkSharp, medalSharp } from 'ionicons/icons';
import {useTranslation} from 'react-i18next';
import { changeLanguage } from 'i18next';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper';
import { IonAccordion, IonAccordionGroup } from '@ionic/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const DiccMaya: React.FC<RouteComponentProps> = ({match}) => {
    const [t,i18n] = useTranslation("global");
    const [err,setErr] = useState<string>();
    const [present] = useIonAlert();
    const history = useHistory();
    const router = useIonRouter();

    const conceptosmaya = [
        "1. Abal",
"2. Bisil",
"3. Bu´ul",
"4. Buut’",
"5. Ch'a cháak",
"6. Cháak",
"7. Chaak",
"8. Chacaj",
"9. Chachak waaj",
"10. Chak",
"11. Chak nuuk nal",
"12. Chak peel",
"13. Chak-chi’",
"14. Chay",
"15. Che’",
"16. Che’chak",
"17. Chéen",
"18. Chi’",
"19. Chi’ abal",
"20. Chi’ikam",
"21. Chíim",
"22. Chuuk",
"23. Chúuk",
"24. Ib",
"25. Iik",
"26. Iis",
"27. Janal",
"28. Janal pixan",
"29. Janli kool",
"30. Janli",
"31. Jets’ Lu’um",
"32. J-men o j-meno'ob",
"33. Jo’os",
"34. Joroch’",
"35. Ka’a",
"36. K’aab",
"37. K’aab iik",
"38. K’an chíim",
"39. K’an",
"40. Ka’an",
"41. Ka’an che’",
"42. k’anXi’im",
"43. k´áax",
"44. K’íiwik",
"45. K’óol",
"46. K’úum Che’",
"47. K’úum",
"48. K’uxub",
"49. Kaaj",
"50. Kaan",
"51. Káax",
"52. K’abax",
"53. K’óopté",
"54. Kool",
"55. Koots’",
"56. Kuum",
"57. Loj kaaj",
"58. Loj korral",
"59. Loj",
"60. Maak kuum",
"61. Maak",
"62. Maak chuuk",
"63. Maak’",
"64. Maatan",
"65. Makal",
"66. Muuk",
"67. NI’",
"68. Nojwaaj",
"69. Okol bat’an",
"70. Óop",
"71. Otoch",
"72. P’aak",
"73. Paax",
"74. Paj",
"75. Paach",
"76. Paach pak´al",
"77. Pak´al",
"78. Payalchí",
"79. Peek’",
"80. Pet pach",
"81. Píib",
"82. Píibinal",
"83. Piich",
"84. Pixan",
"85. Póok chúuk",
"86. Póok",
"87. Pool",
"88. Poolkaan",
"89. Puut",
"90. Sak k’ool",
"91. Sak",
"92. Sak paj",
"93. Sakbej",
"94. Sakxi’im",
"95. Sáal",
"96. Sáalbuut’",
"97. Sikil p’aak",
"98. Sikil",
"99. Spélon",
"100. Tamular",
"101. T´óoj",
"102. Tikin xiik´",
"103. Tikin",
"104. Toksel",
"105. Tóok",
"106. To’",
"107. Ts´ot t´óojbi chay",
"108. Ts´ot",
"109. Ts’ almuy",
"110. Ts’aa",
"111. Ts’am",
"112. Ts’amchaak",
"113. Ts’anchakbi káax",
"114. Ts’íim",
"115. Tsíik",
"116. Tulum",
"117. Tuuch",
"118. Wajil",
"119. Wajil kool",
"120. Wayum",
"121. X nuuk nal",
"122. Xcatic",
"123. Xi’im",
"124. Xiik´",
"125. Xiix",
"126. Xiix",
"127. Xni´peek´",
"128. X-peten aak’",
"129. Ya´",
"130. Yuumtsil",
"131. Yuumtsilo’ob"
];

    const definicionesmaya = [
"Ciruela endémica.",
"Árbol de la región península con frutos parecidos a una manzana diminuta, de ahí se le apropia el termino Manzanita.",
"Frijol negro",
"Embutir/ rellenar. (Técnica)",
"Ceremonia prehispánica basada en un ritual en lenguaje maya, realizada por campesinos para el pedimento de la lluvia en sus milpas, guiada por un J-men",
"lluvia / también hace referencia al Dios de la lluvia.",
"Salcochar o hervir un alimento únicamente con agua y sal. (Técnica).",
"Árbol de la región península de corteza roja y quebradiza, de textura muy suave, utilizada para remedios medicinales locales y como combustible en las cocinas. También conocido como palo mulato.",
"tamal colorado horneado debajo de la tierra.",
"Color rojo/Colorado",
"maíz grande y rojo",
"Caracol rojo maya, utilizado para preparar ceviches.",
"Pez popularmente conocido en la región costera y que adquiere su nombre por la coloración roja de su boca.",
"Chaya, Quelite de la región utilizado para elaborar diversos platillos locales entre los que se destacan, tamales, pipianes, caldos, huevos, e incluso en bebidas.",
"Árbol, Madera",
"Cocer de un solo hervor la carne fresca. (Técnica)",
"Puro, sólo, apenas, simple.",
"Boca",
"se traduciría como chi’: nance y abal: ciruela conformando una ciruela nance, y haciendo referencia al nance por su coloración amarilla y jugosa, esta fruta es muy utilizada para los guisos en los pipianes y como botana en la región.",
"Jícama",
"Escroto; bolsa, bolso. (se puede asociar con el estómago o huevos tiernos.)",
"aprehender, alcanzar, pescar.",
"Carbón",
"Frijol blanco endémico/Frijol de lima",
"Chile",
"Camote",
"Alimento, almuerzo o comer",
"alimento a las ánimas, como festival del día de muertos",
"acción de gracias con ofrendas para la milpa",
"acción de comer",
"ceremonia que se hace en una milpa, ranchería o paraje para neutralizar el infortunio cuando e mueren los animales, se levantan las malas cosechas, se enferma la familia.",
"Sacerdote Maya, especialmente en rituales de milpa y comunidad.",
"Sacar (Técnica)",
"Masa de maíz en forma de un pocillo cónico, que se cuece dentro del caldo de los frijoles, formando un platillo bajo este nombre.",
"dos.",
"caldo.",
"caldo elaborado con chile. Platillo típico de las comunidades mayas de la cocina cotidiana.",
"Huevos tiernos de Tortuga de coloración amarilla, utilizada para consumo humano en las islas. Actualmente está prohibida esta actividad",
"Coloración Amarilla.",
"cielo",
"hace referencia a los huertos elaborados de madera y sostenidos en el cielo, que sirven para resguardar los cultivos más delicados.",
"maíz amarillo",
"Monte o selva.",
"plaza, centro de la población o parque",
"Batir, golpear, abatanar",
"Árbol de calabaza",
"Calabaza",
"achiote",
"Localidad, pueblo, poblado",
"serpiente culebra.",
"Gallina",
"comida sin condimento, simple, sancocho sin sazón.",
"ciricote",
"tumbar monte, desmontar, hacer milpa.",
"enrollar, hacer un rollo o taco",
"Olla",
"Ceremonia prehispánica basada en un ritual en lenguaje maya, realizada por habitantes para la purificación del pueblo, guiada por un J-men",
"Ceremonia que se celebra al bendecir una parcela o corral",
"Redimir, rescatar, desagriviar.",
"Estofado de carne de ave, cerdo o pescado, guisado dentro en una olla tapada (Técnica), también lleva este nombre algunos platillos elaborados bajo esta técnica,solo hay que anteponer la palabra y la proteína guisada, ejemplo “Maak kuum de pescado”",
"Tapa, tapar.",
"cocer tapado.",
"Comer sin masticar y violentamente; comer rápido y mucho.",
"no aparece en el diccionario, pero popularmente se considera como la caridad de compartir en la cuela se da la repartición de la comida a todos los asistentes sin necesidad de invitación.",
"Tubérculo de la región perteneciente al cultivo de la milpa, utilizado para diversos guisos.",
"Enterrar, sepultar. (Técnica)",
"Naríz hocico",
"Tamal ceremonial ofrendado para e",
"Es una ceremonia religiosa que consiste en introducirle tributo a la iglesia.",
"Anona",
"casa/ hogar",
"tomate",
"tocar instrumento musical o música",
"agrio o acedo.",
"detrás, envés o revés de cualquier cosa.",
"detrás de la milpa. Lugar para resguardar hortalizas importantes.",
"platio en general",
"Rezos o plegarias",
"Perro",
"Es un espacio que se selecciona en la milpa, para cultivar mayormente hortalizas, que requieren de mucho sol y que por eso no se intercalan entre el maíz. Además, generalmente requieren de condiciones especiales como puede ser un mejor suelo, o mejor drenado y entonces se selecciona el pedazo con mejores condiciones para sembrar dichas hortalizas. Se procura generalmente que quede en el centro de la milpa, para que no lo ataquen los predadores.",
"Carne horneada en la tierra, horno ancestral que se hace en la tierra, hornear en un poso que se cava en la tierra, esta última referencia hace alusión a la técnica popular utilizada en toda la península de México para la cocción de varios productos alimenticios como: Animales de corral, Animales de la selva, tubérculos, tamales, elotes, alimentos ceremoniales para ofrendar y guisos para fiestas religiosas, sociales, patronales y comunales, entre otros.",
"Elote horneado bajo tierra.",
"parota, orejón, Guanacaste.",
"alma o espíritu",
"Asado al carbón (Técnica), también se le apropia el nombre a un platillo popular de la región península.",
"Asar, tostar (Técnica)",
"Cabeza",
"se definiría como “cabeza de culebra” y corresponde a la forma ovoide que conserva este alimento de la zona popularmente, consiste en masa de maíz relleno con frijoles ibes, pepita tostada y molida, así como cebollin picado, se rellena formando un polcan o cabeza de culebra y ya comúnmente se castellaniza a poolkaanes.",
"Papaya",
"Batido blanco, también se le apropia el nombre a un platillo popular de la región península que tiene esa coloración, textura y forma de hacerse.",
"Blanco",
"es una variedad de nance blanco. En maya se traduce como blanco agrio o acedo. Adopta este nombre debido al aroma del producto.",
"camino blanco realizado para transportarse vía terrestre en el interior de la región península",
"sus. Maíz blanco (su ciclo de producción es de 120 días)",
"liviano o de poco peso",
"popularmente llamado salbut o salbute, que consiste en masa de maíz frita en aceite servida con variedad de vegetales y proteína, generalmente lechuga, tomate, aguacate, cebolla y chile encurtidos y alguna proteína animal. En maya se podía traducir como relleno liviano o de poco peso.",
"es un platillo de las comunidades mayas de Quintana Roo el cual se elabora basado en semillas de calabaza tostadas molidas mezcladas con tomate asado y chile habanero asado y molcajeteado, es considerado un platillo cotidiano.",
"Semilla o Pepita de calabaza",
"frijol verde tierno endémico de la región peninsular, se utiliza para elaborar tamales y diferentes guisos como el frijol de spélon",
"moler con molcajete.",
"Picar",
"se definiría como “Aleta seca”, y es el nombre que se le apropia al platillo típico de Quintana Roo, elaborado con un pescado cocido a las brasas de carbón, previamente aliñado con una marinación de achiote.",
"Seco",
"comida hecha con pepita de calabaza, ibes y cebollina, revuelto todo en una olla, se le agregan piedras calientes para realizar la cocción del alimento",
"quema o quemar.",
"envolver o envoltura.",
"Tamal de la región elaborado con chaya picada y masa de maíz nixtamalizada, el nombre proviene del maya y se traduciría como introducir o meter chaya picada. Describiendo el aspecto del tamal.",
"introducir o meter, (técnica)",
"Saramuyo",
"Poner/colocar (técnica)",
"remojar o sumergir (técnica)",
"alimento cocido únicamente con agua y sal. (Técnica).",
"Caldo de pollo o gallina.",
"Yuca",
"Deshebrar (carne), desmenuzar (técnica)",
"Muralla, trinchera, paliza",
"Ombligo",
"Banquete",
"ceremonia maya de la milpa.",
"huaya",
"sus. Maíz blanco (su ciclo de producción es de 120 días)",
"no aparece en diccionario sin embargo popularmente se asigna este nombre a el chile de coloración amarilla, poco picoso, utilizado para varios guisos, endémico y muy parecido al chile güero o chile de agua.",
"Maíz",
"Axila, ala, aleta.",
"Carne, vísceras y retacería de res que se fríe en su propia grasa o cebo.",
"Resto, asiento, sedimento.",
"Se traduciría como “hocico de perro” y es el nombre popular que se le asigna al platillo elaborado de ibes blancos, cebollina y pepita molida, debido a que el picor de esta preparación produce fluidos en la nariz.",
"enser de la cocina maya que consiste en la circunferencia de bejuco cuyo interior está cocido con hilos de henequén.",
"Zapote blanco o chicozapote.",
"Dios, Señor.",
"dios del lugar o de la milpa."
    ];

    const ejemplosuso = [
        "","","","","","","","",
        "","","","","","","","","","","","","",
        "","","","","","","","","","","","","",
        "","","","","","","","","","","","","",
        "","","","","","","","","","","","","",
        "","","","","","","","","","","","","",
        "","","","","","","","","","","","","",
        "","","","","","","","","","","","","",
        "","","","","","","","","","","","","",
        "","","","","","","","","","","","",""
    ];

    console.log('Language: ',i18n.language);

    const langEnable = i18n.language;
    let mtitle="", mdesc="", mcurrent="", luginteres="", mname6 = "", mhowgochit6 = "";

    switch(langEnable){
        case 'es':
            mtitle = 'Glosario Maya Quintanarroense';
            mdesc = 'En este momento Usted se encuentra en la Riviera Maya. En el Estado de Quintanma Roo, México. Quintana Roo es una región única en el mundo, diversa en cuanto a destinos y atractivos turísticos. Ofrece mar azul, playas de arena blanca, selva tropical, zonas arqueológicas, cenotes, ríos subterráneos, islas, lagunas, cultura Maya viva e historia.';
            mcurrent = 'Como su nombre lo indica, la Riviera Maya fue habitada originalmente por el pueblo maya desde el 200 a. C. Si bien las ciudades que florecieron en la zona no se comparaban a Tikal , Calakmul o Chichen Itzá en cuanto a infraestructura, aún seguían teniendo construcciones en la que se emplearon bases matemáticas y alto nivel de precisión, artes e ingeniería, heredadas de la influencia del Petén y la región Puuc.';
            luginteres = "Lugares de interés cerca de donde te encuentras...";
            mname6 = "Gran Museo del Mundo Maya";
            mhowgochit6 = "El Gran Museo del Mundo Maya de Mérida es un lugar de aprendizaje en donde se encuentra lo mejor de las enseñanzas de nuestra cultura, de nuestra relación con la naturaleza y con el conocimiento acumulado a través de la historia, saber que se proyecta en la manera en que imaginamos el futuro y pretendemos actuar para incidir en él, modificarlo para nuestro crecimiento personal y para el bienestar de la sociedad.";
            break;
        case 'en':
            mtitle = 'Quintana Roo Maya Glossary';
            mdesc = 'Right now you are in the Riviera Maya. In the State of Quintana Roo, Mexico. Quintana Roo is a unique region in the world, diverse in terms of destinations and tourist attractions. It offers blue sea, white sand beaches, rainforest, archaeological sites, cenotes, underground rivers, islands, lagoons, living Mayan culture and history.';
            mcurrent = 'As the name claims, the Riviera Maya was originally inhabited by the Mayan people as early as 200 BC. Although the cities that flourished in the area did not compare to Tikal, Calakmul or Chichen Itzá in terms of infrastructure, they still had constructions in which mathematical bases and a high level of precision, arts and engineering were used, inherited from the influence of the Petén and the Puuc region.';
            luginteres = "Places of interest near you...";
            mname6 = "Great Museum of the Mayan World";
            mhowgochit6 = "The Great Museum of the Maya World of Merida is a place of learning where we find the best of the teachings of our culture, of our relationship with nature and with the knowledge accumulated throughout history, knowledge that is projected in the way we imagine the future and intend to act to influence it, to modify it for our personal growth and for the welfare of society. The contents of the Museum are designed with the conviction that due to its nature and its interdisciplinary aspects, it will respond not only to the genuine aspirations and demands of a society, but also to the need to participate at a global level with any initiative that strengthens identity, education, cultural tourism and consequently social and economic development and the generation of employment. It is a proposal that corresponds to its time and generates, in its journey, a process of cultural communication with visitors through interactive, digital systems, projections, immersion rooms, audiovisuals and internet lines. The Government of the State of Yucatan, through the National Institute of Anthropology and History and the Institute of History and Museums of Yucatan establish that the Great Museum of the Mayan World of Merida is in an ideal position to derive greater benefits in the future, from the appropriation of citizens and the growing number of cultural tourists that incorporate it in their tours. The Museum exhibits a magnificent collection of more than 1,160 pieces that allows visitors to enjoy, among other examples, textiles, religious elements, pieces and diverse objects and furnishings that reflect the current daily life of the Mayas. Also on display are engravings, books and historical documents, as well as artistic and religious works from the colonial period; collections from the pre-Hispanic period that include stelae, bas-reliefs and stone sculptures; pottery vessels, trousseaus and offerings, as well as ornaments and sumptuary objects made of gold, jade and shell. All this forms a framework where the past and the present are combined through new technologies and digital systems to allow the visitor to travel through time and return to the present. The rooms begin with the current panorama of the Mayan culture and then delve into the past of this ancient people.";
            break;
        case 'fr':
            mtitle = 'Quintana Roo Maya Glossaire';
            mdesc = 'En ce moment, vous êtes sur la Riviera Maya. Dans l’État de Quintana Roo, au Mexique. Quintana Roo est une région unique au monde, diversifiée en termes de destinations et d’attractions touristiques. Il offre une mer bleue, des plages de sable blanc, une forêt tropicale, des sites archéologiques, des cenotes, des rivières souterraines, des îles, des lagunes, une culture et une histoire mayas vivantes.';
            mcurrent = 'Comme son nom l’indique, la Riviera Maya était à l’origine habitée par le peuple maya depuis 200 av. J.-C. Bien que les villes qui ont prospéré dans la région ne se comparent pas à Tikal, Calakmul ou Chichen Itzá en termes d’infrastructures, elles avaient encore des constructions dans lesquelles des bases mathématiques et un haut niveau de précision, d’art et d’ingénierie étaient utilisés, hérités de l’influence du Petén et de la région de Puuc.';
            luginteres = "Lieux d’intérêt près de chez vous...";
            mname6 = "Grand musée du monde maya";
            mhowgochit6 = "Le Grand Musée du Monde Maya de Mérida est un lieu d'apprentissage où l'on trouve le meilleur des enseignements de notre culture, de notre relation avec la nature et avec les connaissances accumulées tout au long de l'histoire, connaissances qui sont projetées dans la manière dont nous imaginons l'avenir et dont nous avons l'intention d'agir pour l'influencer, le modifier pour notre croissance personnelle et pour le bien-être de la société. Le contenu du musée est conçu avec la conviction qu'en raison de sa nature et de ses aspects interdisciplinaires, il répondra non seulement aux aspirations et aux exigences réelles d'une société, mais aussi à la nécessité de participer au niveau mondial à toute initiative qui renforce l'identité, l'éducation, le tourisme culturel et, par conséquent, le développement social et économique et la création d'emplois. Il s'agit d'une proposition qui correspond à son époque et qui génère, dans son parcours, un processus de communication culturelle avec les visiteurs par le biais de systèmes interactifs et numériques, de projections, de salles d'immersion, d'audiovisuels et de lignes Internet. Le gouvernement de l'État du Yucatan, par l'intermédiaire de l'Institut national d'anthropologie et d'histoire et de l'Institut d'histoire et des musées du Yucatan, établit que le Grand musée du monde maya de Mérida se trouve dans une position idéale pour obtenir de plus grands bénéfices à l'avenir, grâce à l'appropriation citoyenne et au nombre croissant de touristes culturels qui l'intègrent dans leurs circuits. Le musée expose une magnifique collection de plus de 1 160 pièces qui permet aux visiteurs d'apprécier, entre autres exemples, des textiles, des éléments religieux, des pièces et divers objets et mobiliers qui reflètent la vie quotidienne des Mayas d'aujourd'hui. Sont également exposés des gravures, des livres et des documents historiques, ainsi que des œuvres artistiques et religieuses de la période coloniale ; des collections de la période préhispanique comprenant des stèles, des bas-reliefs et des sculptures en pierre ; des récipients en poterie, des trousseaux et des offrandes, ainsi que des ornements et des objets somptuaires en or, en jade et en coquillage. Le tout forme un cadre où le passé et le présent se rejoignent à travers les nouvelles technologies et les systèmes numériques pour permettre au visiteur de voyager dans le temps et de revenir dans le présent. Les salles présentent d'abord le panorama actuel de la culture maya, puis plongent dans le passé de ce peuple millénaire.";
            break;
        case 'zh':
            mtitle = 'Quintana Roo Maya 詞彙表';
            mdesc = '今在里维埃拉玛雅。 在墨西哥金塔纳罗奥州。 金塔纳罗奥州者,世界之独无二也,在目与旅游景点异。 供蔚海、白沙、热带雨林、考古遗址、天然井、地下河、岛屿、泻湖、生玛雅文史。';
            mcurrent = '顾名思义,里维埃拉玛雅自公元前 200 以来始居玛雅人。 虽蓬勃发展城邑基础设施不得与蒂卡尔、卡拉克穆尔、奇琴伊察比,然犹有数学之基,高精度艺之功,继佩滕普克之化。';
            luginteres = "近景点...";
            mname6 = "玛雅世界大博物馆";
            mhowgochit6 = "梅里達瑪雅世界大博物館是一個學習的地方，在這裡我們可以找到我們文化中最好的教誨、我們與自然的關係以及歷史上累積的知識，這些知識投射在我們對未來的想像中，並打算採取行動來影響未來，為了我們個人的成長和社會的福祉而改變未來。博物館的內容設計深信，基於其本質和跨學科方面，它不僅能回應社會的真正願望和需求，還能回應在全球層面參與任何強化身份認同、教育、文化旅遊，從而促進社會和經濟發展以及創造就業機會的需要。這是一項與時並進的提案，透過互動、數位系統、投影、沉浸式房間、視聽和網路線路，在旅途中與遊客進行文化交流。猶卡坦州政府透過國家人類學及歷史研究所和猶卡坦歷史及博物館研究所確定，梅里達瑪雅世界大博物館處於一個理想的位置，未來將基於公民使用權和將其納入旅遊行程的文化遊客數量不斷增加而獲得更大的利益。博物館展示了超過 1,160 件精美的藏品，讓參觀者可以欣賞到紡織品、宗教元素、反映瑪雅人現今日常生活的物品和陳設。同時展出的還有雕版畫、書籍和歷史文件，以及殖民時期的藝術和宗教作品；前西班牙時期的藏品，包括石碑、浮雕和石雕；陶器、褲襪和祭品，以及用黃金、玉石和貝殼製成的飾物和擺設。所有這些構成了一個框架，通過新技術和數位系統將過去和現在聯繫在一起，讓參觀者穿越時光回到現在。這些展室從現在的瑪雅文化全景開始，接著深入這個千年民族的過去。";
            break;
        case 'maya':
            mtitle = "Glosario Maya Quintanarroense";
            mdesc = "Ti' le súutuka' tech Kula'an ti' le Riviera Maya. Ti' le noj u Quintanma Roo, México. Quintana Roo jach jump'éel región chen kaabe', ya'abach en cuanto a destinos yéetel atractivos turísticos. K'u'ubul k'áak'náabo' ch'ooj, playas arena sak, u k'áaxil tropical, zonas arqueológicas, ts'ono'oto'ob, buuts' subterráneos, islas, lagunas, miatsil maaya viva yéetel k'ajláayo'.";
            mcurrent = "Bix u k'aaba' le indica, le Riviera Maya bin habitada originalmente tumen le kaajo' maaya tak le 200 u. kuxtal Wa bien le ciudades florecieron ti' le kúuchila' ma' u comparaban u Tikal, Calakmul wa Chichen Itzá en cuanto a meyaje', láayli' seguían teniendo construcciones ti' le ba'ax ku emplearon bases matemáticas yéetel ka'anal nivel u precisión, Arteso' yéetel ingeniería, heredadas u influencia le Petén yéetel le petenil Puuc.";
            mname6 = "Nojoch Museo ti' le yóok'ol kaaba' Maya";
            mhowgochit6 = "Le nuxi' Museo ti' le yóok'ol kaaba' maaya u jo' le jump'éel kúuchil je'elo'oba' tu'ux Kula'an asab ti' le enseñanzas k miaatsil u k relación yéetel le ku, yéetel u yóol acumulado ti' le k'ajláayo', wojéeltik ba'ax ku proyecta ti' bix ken ku imaginamos le futuro yéetel pretendemos kan utia'al incidir ti' leti'e',  modificar utia'al k tuméen máaxo'ob yéetel utia'al del bienestar le. Le contenidos le Museo táan diseñados yéetel u convicción ti' u tuméen u ku yéetel u vertientes interdisciplinarias, responderán ma' chéen le aspiraciones yéetel demandas genuinas ti' jump'éel kajnáalilo'ob, sino in kajtalo'ob ichil u táan u táakpajalo'ob ti' mundial yéetel tuláakal poolilta'ab ku fortalezca u, le educación, le turismo miatsil yéetel tu consecuencia le ma'alo'ob ts'aa,  económico yéetel le generación empleos. ";
            break;
    }

      const navigate = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        router.push('/app/tabs');
    };
      
    
        return (
            <IonPage>
                <IonHeader>
                    <IonToolbar className='custom'>
                        <IonButtons slot='start'>
                          <IonButton onClick={(event) => navigate(event)} color='light'>
                              <IonIcon icon={arrowBack} size='medium'></IonIcon> 
                          </IonButton>
                      </IonButtons>
                      <IonTitle className="nombre-marca">Mexico Profundo</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent fullscreen={true} className="ion-padding">
                    <div className="content-museo">
                        <div className="title-name">
                            <h1>{mtitle}</h1>
                        </div>
                    </div>
                    <IonAccordionGroup>
                        {conceptosmaya.map((item, index) => (
                            <IonAccordion key={index} value={item}>
                            <IonItem slot="header">
                                <IonLabel>{item}</IonLabel>
                            </IonItem>
                            <div className="ion-padding" slot="content">
                                {definicionesmaya[index]}
                            </div>
                            </IonAccordion>
                        ))}
                    </IonAccordionGroup>
                                
                </IonContent>


            </IonPage>
        );
    
};

export default withIonLifeCycle(DiccMaya);